// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import "./WebDevelopement.css";
// import sampleImage from "../../../Image/imp1.jpg";

// const newsData = [
//   {
//     title: "Full Stack MERN Development",
//     category: "Technology",
//     description:
//       "Learn MongoDB, Express, React, Node.js, Authentication, APIs, Deployment and real projects that make you job-ready.",
//     image: sampleImage,
//   },
//   {
//     title: "Python + Data Science",
//     category: "Trending",
//     description:
//       "Python basics to advanced, NumPy, Pandas, AI models, machine learning and real analytics industry case studies.",
//     image: sampleImage,
//   },
//   {
//     title: "UI/UX Design With Figma",
//     category: "Design",
//     description:
//       "Learn wireframing, color theory, typography, UX strategy and animation-ready prototype using top design workflow.",
//     image: sampleImage,
//   },
// ];

// const NewsCardComponent = () => {
//   const [expandedIndex, setExpandedIndex] = useState(null);

//   const toggleDescription = (index) => {
//     setExpandedIndex(expandedIndex === index ? null : index);
//   };

//   return (
//     <div className="news-card-container">
//       {newsData.map((item, index) => (
//         <motion.div
//           key={index}
//           className="news-card"
//           initial={{ opacity: 0, y: 80, rotateX: -30 }}
//           whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//           viewport={{ once: true, amount: 0.3 }}
//           whileHover={{
//             scale: 1.02,
//             x: 8,
//             boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
//           }}
//         >
//           {/* LEFT --- IMAGE (30%) */}
//           <motion.div
//             className="left-image-container"
//             initial={{ rotateY: -90 }}
//             whileInView={{ rotateY: 0 }}
//             transition={{ duration: 0.7 }}
//           >
//             <img src={item.image} alt={item.title} className="card-image" />
//           </motion.div>

//           {/* RIGHT --- TEXT (70%) */}
//           <motion.div
//             className="card-text"
//             initial={{ scale: 0.7, opacity: 0 }}
//             whileInView={{ scale: 1, opacity: 1 }}
//             transition={{ duration: 0.7 }}
//           >
//             <motion.div
//               className="card-title-row"
//               onClick={() => toggleDescription(index)}
//               whileHover={{ backgroundColor: "#eefef6" }}
//             >
//               <span className="card-title">{item.title}</span>
//               <span className="card-category">{item.category}</span>
//               <motion.span
//                 animate={{ rotate: expandedIndex === index ? 90 : 0 }}
//                 transition={{ duration: 0.3 }}
//                 className="card-arrow"
//               >
//                 ➤
//               </motion.span>
//             </motion.div>

//             <AnimatePresence>
//               {expandedIndex === index && (
//                 <motion.div
//                   className="card-description"
//                   initial={{ opacity: 0, height: 0 }}
//                   animate={{ opacity: 1, height: "auto" }}
//                   exit={{ opacity: 0, height: 0 }}
//                   transition={{ duration: 0.4 }}
//                 >
//                   {item.description}
//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </motion.div>
//         </motion.div>
//       ))}
//     </div>
//   );
// };

// export default NewsCardComponent;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What is web development and what does it include?",
    // category: "Technology",
    description:
      "Web development involves creating websites and web applications using HTML for structure, CSS for styling, and JavaScript for interactivity. It may also include backend data handling, making it a combination of frontend, backend, or full-stack work.",
  },
  {
    title: "What are the core technologies used in web development?",
    // category: "Trending",
    description:
      "Core web development relies on HTML for content, CSS for styling, and JavaScript for dynamic behavior. As you advance, you’ll learn frameworks like React, backend tools like Node.js or PHP, and databases such as MySQL or MongoDB.",
  },
  {
    title: "What kind of projects will I build as a web development student?",
    // category: "Design",
    description:
      "You’ll create projects like landing pages, portfolios, blogs, login systems, and responsive websites. As you advance, you can build more complex applications, including e-commerce sites, interactive dashboards, and fully dynamic, real-world web applications.",
  },
  {
    title: "What is responsive design, and why is it important?",
    // category: "Design",
    description:
      "Responsive design ensures websites work on all devices, including phones, tablets, and desktops. It uses CSS techniques like Flexbox, Grid, and media queries to automatically adjust layouts for different screen sizes and resolutions.",
  },
  {
    title: "Is web development good for freelancing?",
    // category: "Design",
    description:
      "Yes, web development is a top freelancing skill. Businesses frequently need websites, redesigns, landing pages, e-commerce stores, and updates, making it easy to secure freelance projects once you build a strong portfolio.",
  },
];

const NewsSection = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        {/* LEFT IMAGE BLOCK (Only One Image) */}
        {/* <motion.div
        className="news-left-image"
        initial={{ rotateY: -90, opacity: 0 }}
        whileInView={{ rotateY: 0, opacity: 1 }}
        transition={{ duration: 0.9, ease: "easeOut" }}
        viewport={{ once: true }}
      > */}

        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        {/* RIGHT SECTION */}
        {/* <motion.div
        className="news-right-list"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      > */}
        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              {/* <AnimatePresence>
              {expandedIndex === index && (
                <motion.div
                  className="description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.div>
              )}
            </AnimatePresence> */}
              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default NewsSection;
